import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { ABOUT_PILLARS } from "../../lib/data";

const HANDSHAKE =
  "https://images.pexels.com/photos/8112186/pexels-photo-8112186.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const AboutSection = () => (
  <section id="about" className="bg-fog py-24 md:py-32" data-testid="about-section">
    <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 md:px-8 lg:grid-cols-2 lg:gap-24">
      <div>
        <SectionHeading
          overline="About LendX"
          title="Built Around Better Financial Decisions"
          testId="about-heading"
        />
        <Reveal delay={0.2}>
          <p className="mt-6 text-base leading-relaxed text-gray-600 md:text-lg">
            LendX focuses on simplifying access to financial solutions through professional advisory, structured financing approaches, and personalized client support. Our objective is to help clients understand their financing options and navigate the funding process with greater clarity and confidence.
          </p>
        </Reveal>
        <div className="mt-10 space-y-6">
          {ABOUT_PILLARS.map((p, i) => {
            const Icon = p.icon;
            return (
              <Reveal key={p.title} delay={0.1 + i * 0.08} y={24}>
                <div className="flex gap-5" data-testid={`about-pillar-${i + 1}`}>
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg border border-gold-line bg-gold-tint text-gold-deep">
                    <Icon size={19} strokeWidth={1.6} />
                  </span>
                  <div>
                    <h3 className="font-heading text-lg font-semibold text-navy">{p.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-gray-600">{p.text}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={0.35}>
          <Link
            to="/about"
            data-testid="about-more-link"
            className="group mt-10 inline-flex items-center gap-2 text-sm font-semibold text-gold-deep"
          >
            More About LendX
            <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>

      <Reveal delay={0.15} className="relative">
        <div className="absolute -left-4 -top-4 h-full w-full rounded-2xl border border-gold/40" />
        <div className="relative overflow-hidden rounded-2xl shadow-[0_16px_48px_rgba(16,20,24,0.12)]" data-testid="about-image">
          <img src={HANDSHAKE} alt="LendX advisors sealing a financing partnership with a handshake" loading="lazy" className="h-[420px] w-full object-cover md:h-[520px]" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-transparent to-transparent" />
          <div className="absolute bottom-6 left-6 right-6">
            <p className="font-heading text-xl font-semibold text-white md:text-2xl">Your Finance. Simplified.</p>
            <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.25em] text-gold">The LendX Promise</p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
